import { Stack } from "@mui/material";
import { AwarenessTestsConfig, GameSpeedConfig, RatingConfig, ScenarioCountConfig, SlowtimeConfig } from ".";

const PractiseSettings = () => {
  return (
    <Stack flexDirection="column" flex={0.4} gap={3}>
      <GameSpeedConfig />
      <RatingConfig />
      <ScenarioCountConfig />
      <AwarenessTestsConfig />
      <SlowtimeConfig />
    </Stack>
  );
};

export default PractiseSettings;
